import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { faBluesky as bluesky } from '@fortawesome/free-brands-svg-icons/faBluesky';
import { faCcVisa as ccVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa';
import { faDiscord as discord } from '@fortawesome/free-brands-svg-icons/faDiscord';
import { faFacebook as facebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faGithub as github } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram as instagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn as linkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faMedium as medium } from '@fortawesome/free-brands-svg-icons/faMedium';
import { faNpm as npm } from '@fortawesome/free-brands-svg-icons/faNpm';
import { faProductHunt as productHunt } from '@fortawesome/free-brands-svg-icons/faProductHunt';
import { faReddit as reddit } from '@fortawesome/free-brands-svg-icons/faReddit';
import { faTelegram as telegram } from '@fortawesome/free-brands-svg-icons/faTelegram';
import { faTiktok as tiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faXTwitter as xTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube as youtube } from '@fortawesome/free-brands-svg-icons/faYoutube';

const icons: Record<string, IconDefinition> = {
  bluesky,
  ccVisa,
  discord,
  facebook,
  github,
  instagram,
  linkedinIn,
  medium,
  npm,
  productHunt,
  reddit,
  telegram,
  tiktok,
  xTwitter,
  youtube,
};

export default icons;
